import styles from '@styles/screens/StartDemoScreen.module.css'
import { HorizontalContainer, VerticalContainer, VerticalSpacer } from "@components/General/Containers"
import { H2Title, Subtitle } from "@components/General/Titles"
import designSystem from "@styles/designSystem"
import { NormalButton } from '@components/General/Button';
import { QontactLogoPanel } from '@components/QontactLogoPanel';
import { useQRScreenViewModel } from '../view-models/QRCodeScreenViewModel';
import { ReactComponent as PhoneMockupSVG } from '@assets/SVGs/PhoneMockup.svg'; // Adjust path as needed
import { ReactComponent as QontactTextSVG } from '@assets/SVGs/GeneralUse/Qontact.svg';
import { ReactComponent as QontactBackgroundSVG } from '@assets/SVGs/GeneralUse/QontactBackground.svg';
import { isMobile } from 'react-device-detect';
import { useEffect } from 'react';

export const QRCodeScreen: React.FC = () => {
    const {
        qrCodeUrl,
        qpId,
        isLoading,
        handleAlreadyDone,
        viewDidAppear,
    } = useQRScreenViewModel();

    // viewDidAppear - runs only once when component first mounts
    useEffect(() => {
        viewDidAppear()
    }, []) // Empty dependency array ensures this runs only once

    return (
        <HorizontalContainer 
            gap={designSystem.gapNone}
            height={'100%'}
        >
            {/* Left Panel - Phone Mockup */}
            <VerticalContainer 
                maxWidth={'50%'} 
                height={'100%'}
                alignment={'center'}
                backgroundColor={designSystem.colorMainAction}
            >
                <VerticalContainer 
                    width={'100%'}
                    height={'100%'}
                    alignment={'center'}
                    backgroundColor={designSystem.colorMainAction}
                >
                    <QontactBackgroundSVG 
                        viewBox={isMobile ? "0 0 700 305" : "0 0 700 1050"} 
                        className={styles['qontact-background']}
                        style={{ pointerEvents: 'none' }}
                    />
                    <div style={{
                        width: '400px',   
                        height: '100%',
                        alignContent: 'center'
                    }}>
                        <VerticalContainer alignment={"center"} gap={designSystem.gapLg} width={"100%"}>
                            <QontactTextSVG style={{ maxWidth: '200px', height: 'auto'}}/>
                            <PhoneMockupSVG style={{ maxWidth: '400px', height: 'auto'}} />
                        </VerticalContainer>
                    </div>

                </VerticalContainer>

            </VerticalContainer>
            
            {/* Right Panel - QR Code */}
            <VerticalContainer 
                maxWidth={'50%'} 
                alignment={'center'}
                backgroundColor={designSystem.colorBackgroundGray3}
            >
                <VerticalSpacer/>
                <VerticalContainer width={'600px'} gap={designSystem.gapLg}>                    
                    <VerticalContainer gap={designSystem.gapNone}>
                        <H2Title text={"Escanea el QR".localized()}/>
                        <Subtitle text={"Cuando vas a hacer una fichada, solamente debes escanear este QR y te llevará a una conversación con nuestro BOT en Whatsapp".localized()}/>
                    </VerticalContainer>

                    {/* QR Code Display */}
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: '40px',
                        backgroundColor: '#fff',
                        borderRadius: '12px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    }}>
                        {isLoading ? (
                            <div style={{ 
                                width: '400px', 
                                height: '400px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: designSystem.colorBackgroundGray2,
                                borderRadius: '8px',
                            }}>
                                <p style={{ color: designSystem.colorWarningText }}>
                                    {"Generando QR...".localized()}
                                </p>
                            </div>
                        ) : qrCodeUrl ? (
                            <img 
                                src={qrCodeUrl} 
                                alt="QR Code" 
                                style={{ 
                                    width: '400px', 
                                    height: '400px',
                                    imageRendering: 'pixelated',
                                }}
                            />
                        ) : (
                            <div style={{ 
                                width: '400px', 
                                height: '400px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: designSystem.colorBackgroundGray2,
                                borderRadius: '8px',
                            }}>
                                <p style={{ color: designSystem.colorWarningText }}>
                                    {"Error al generar QR".localized()}
                                </p>
                            </div>
                        )}
                    </div>

                    {qpId && (
                        <p style={{ 
                            textAlign: 'center',
                            color: designSystem.colorTextSecondary,
                            fontSize: designSystem.fontSizeSm,
                            margin: 0,
                        }}>
                            ID: {qpId}
                        </p>
                    )}

                    <NormalButton 
                        text={"Ya lo hice".localized()}
                        width={"300px"}
                        onClick={handleAlreadyDone}
                        disabled={isLoading}
                    />
                </VerticalContainer>
                <VerticalSpacer/>
            </VerticalContainer>
        </HorizontalContainer>
    );
};